export const calculateDeviation = (actual, target) => {
    if (!actual || !target || target === 0) return null;
    return ((actual - target) / target * 100).toFixed(2);
};

export const getCalibrationStatus = (dueDate) => {
    if (!dueDate) return { status: 'unknown', color: 'default' };
    const dayjs = require('dayjs');
    const daysTillDue = dayjs(dueDate).diff(dayjs(), 'day');
    if (daysTillDue < 0) return { status: 'overdue', color: 'error' };
    if (daysTillDue < 30) return { status: 'due soon', color: 'warning' };
    return { status: 'calibrated', color: 'success' };
}; 